module.exports = __webpack_public_path__ + "img/kuang3.de7e133a.png";